export const ICON_SIZE_PX = '24px';
export const ICON_COLOR = 'rgba(0, 0, 0, 0.5)';
